export const buildTimeInputValueOnDayTimeChange = (
  currentValue: string,
  displayHours: string,
  dayTime: 'AM' | 'PM',
): string => {
  const minutes = currentValue.split(':')[1] ?? '00';
  let hours24 = displayHours;

  if (displayHours === '12' && dayTime === 'AM') {
    hours24 = '00';
  } else if (displayHours === '12' && dayTime === 'PM') {
    hours24 = '12';
  } else if (dayTime === 'PM') {
    hours24 = `${parseInt(displayHours, 10) + 12}`;
  }

  return `${hours24}:${minutes}`;
};
